import { render, staticRenderFns } from "./FifthSettingsComp.vue?vue&type=template&id=4fe9aa32&scoped=true&"
import script from "./FifthSettingsComp.vue?vue&type=script&lang=js&"
export * from "./FifthSettingsComp.vue?vue&type=script&lang=js&"
import style0 from "./FifthSettingsComp.vue?vue&type=style&index=0&id=4fe9aa32&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fe9aa32",
  null
  
)

export default component.exports